import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { AngularFireModule, FirebaseApp } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { firebaseConfig } from './../environments/environment'
import { ImageUploadModule } from "angular2-image-upload";
import { AddBrickComponent } from './components/add-brick/add-brick.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpdateBrickComponent } from './components/update-brick/update-brick.component';
import { OrderComponent } from './components/order/order.component';
import { AgmCoreModule } from '@agm/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { CategoryComponent } from './components/category/category.component';
import { AuthGuard } from './guards/auth.guard';
import { EditorModule } from '@tinymce/tinymce-angular';
import { AddReferenceComponent } from './components/add-reference/add-reference.component';
import { BrickPreviewComponent } from './components/brick-preview/brick-preview.component';
import { PartnerComponent } from './components/partner/partner.component';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccountComponent } from './components/account/account.component';
import { ChatComponent } from './components/chat/chat.component';
import { CouponComponent } from './components/coupon/coupon.component';
import { AddCouponComponent } from './components/add-coupon/add-coupon.component';

@NgModule({
    declarations: [
        AppComponent,
        AddBrickComponent,
        UpdateBrickComponent,
        OrderComponent,
        CategoryComponent,
        AddReferenceComponent,
        BrickPreviewComponent,
        PartnerComponent,
        AccountComponent,
        ChatComponent,
        CouponComponent,
        AddCouponComponent
    ],
    entryComponents: [
        AddBrickComponent,
        UpdateBrickComponent,
        OrderComponent,
        CategoryComponent,
        AddReferenceComponent,
        BrickPreviewComponent,
        PartnerComponent,
        AccountComponent,
        ChatComponent,
        CouponComponent,
        AddCouponComponent
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            mode: 'ios',
        }),
        AppRoutingModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireAuthModule,
        AngularFireDatabaseModule,
        AngularFirestoreModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ImageUploadModule.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBBURLg6G2RMj66jj-iDTAhMVDQxRRel9w',
            libraries: ['places']
        }),
        EditorModule,
        BrowserAnimationsModule,
        NgxChartsModule
    ],
    providers: [
        StatusBar,
        SplashScreen,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        AuthGuard
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
